import { render } from "./ContactUsPopup.vue?vue&type=template&id=04541479&scoped=true"
import script from "./ContactUsPopup.vue?vue&type=script&lang=js"
export * from "./ContactUsPopup.vue?vue&type=script&lang=js"

import "./ContactUsPopup.vue?vue&type=style&index=0&id=04541479&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04541479"]])

export default __exports__